import React, {useState} from 'react';
import OeTip from './OeTip';
import {STAMM_LABELS, STAMM_NONE} from './availability';

/**
 * Aktionsleiste der Mehrfachauswahl (Ticket #124, Sarah: „mehrere Positionen
 * auswählen … zum Lager umstellen oder auch Rabatte einfügen“).
 *
 * Alles bleibt vorgemerkt bis „Speichern“ — wie jede Änderung in der Tabelle.
 * Set-Köpfe und gesperrte Zeilen lassen sich gar nicht erst auswählen.
 *
 * @param {number} count - Zahl der gewählten Zeilen.
 * @param {boolean} canStamm - „Liefern ab“ ist nur im Bestands-Schritt änderbar.
 * @param {Function} onApply - (field, value) => void
 * @param {Function} onClear - Auswahl aufheben.
 */
export default function BulkBar({count, canStamm, onApply, onClear}) {
    const [disc, setDisc] = useState('');
    const [qty, setQty] = useState('');

    if (!count) {
        return null;
    }

    const zahl = (text) => String(text).replace(',', '.').trim();
    const discOk = zahl(disc) !== '' && Number(zahl(disc)) >= 0 && Number(zahl(disc)) <= 100;
    const qtyOk = zahl(qty) !== '' && Number(zahl(qty)) > 0;

    return (
        <div className="bulkbar" role="toolbar" aria-label="Aktionen für die ausgewählten Positionen">
            <span className="bb-count"><b>{count}</b> ausgewählt</span>

            {canStamm ? (
                <span className="bb-group">
                    <span className="muted">Liefern ab</span>
                    {['Lahr', 'SNV', 'Cosmos', STAMM_NONE].map((ziel) => (
                        <OeTip
                            key={ziel}
                            tip={ziel === STAMM_NONE
                                ? `Die ${count} Positionen werden nicht geliefert (Lager „Keine“) und erscheinen als Fehlmenge.`
                                : `Stellt die ${count} Positionen auf „ab ${STAMM_LABELS[ziel] || ziel}“. Das Auftragslager bleibt.`}
                        >
                            <button type="button" className="saseg" onClick={() => onApply('stamm', ziel)}>
                                {STAMM_LABELS[ziel] || ziel}
                            </button>
                        </OeTip>
                    ))}
                </span>
            ) : null}

            <span className="bb-group">
                <OeTip tip="Rabatt in Prozent für alle ausgewählten Positionen (0 bis 100).">
                    <input
                        className="bb-in"
                        inputMode="decimal"
                        autoComplete="off"
                        aria-label="Rabatt in Prozent"
                        placeholder="Rabatt %"
                        value={disc}
                        onChange={(e) => setDisc(e.target.value)}
                    />
                </OeTip>
                <OeTip tip={`Setzt den Rabatt an den ${count} Positionen; wirksam mit „Speichern“.`}>
                    <button
                        type="button"
                        className="saseg"
                        disabled={!discOk}
                        onClick={() => { onApply('discountPercentage', zahl(disc)); setDisc(''); }}
                    >
                        Rabatt setzen
                    </button>
                </OeTip>
            </span>

            <span className="bb-group">
                <OeTip tip="Neue Menge für alle ausgewählten Positionen.">
                    <input
                        className="bb-in"
                        inputMode="decimal"
                        autoComplete="off"
                        aria-label="Menge"
                        placeholder="Menge"
                        value={qty}
                        onChange={(e) => setQty(e.target.value)}
                    />
                </OeTip>
                <OeTip tip={`Setzt die Menge an den ${count} Positionen; wirksam mit „Speichern“.`}>
                    <button
                        type="button"
                        className="saseg"
                        disabled={!qtyOk}
                        onClick={() => { onApply('quantity', zahl(qty)); setQty(''); }}
                    >
                        Menge setzen
                    </button>
                </OeTip>
            </span>

            <span className="bb-group">
                <OeTip tip={`Markiert die ${count} Positionen zum Löschen; erst „Speichern“ entfernt sie in weclapp.`}>
                    <button type="button" className="saseg reset" onClick={() => onApply('del', true)}>
                        zum Löschen markieren
                    </button>
                </OeTip>
                <OeTip tip="Hebt die Auswahl auf, ohne etwas zu ändern.">
                    <button type="button" className="link" onClick={onClear}>Auswahl aufheben</button>
                </OeTip>
            </span>
        </div>
    );
}
